import React from "react";
import { Col, Row, Divider } from "antd";

import { PlusCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import IntlMessages from "../../../util/IntlMessages";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { APP_ROUTES } from "../../../constants/Routes";

const QualificationHeader = () => {
  return (
    <div>
      <Row className="p-10 Add-button">
        <Col>
          <p className="header-tag">
            {<IntlMessages id={"Addnew.qualification"} />}
          </p>
        </Col>
        <Col>
          <Link to={APP_ROUTES.ADDNEWQUALIFICATION}>
            <ButtonComponent
              className="buttons"
              icon={<PlusCircleOutlined />}
              type="primary"
              label="Add New"
            />
          </Link>
        </Col>
      </Row>

      <Divider />
    </div>
  );
};

export default QualificationHeader;
